// Dev-only clock override.

const DEV_NOW_COOKIE = 'zoe.dev_now';

let overrideMs: number | null = null;

/** Set (or clear) the pinned dev clock. */
export function setDevNowOverride(value: string | null | undefined): void {
  if (!import.meta.env.DEV || !value) {
    overrideMs = null;
    return;
  }
  const parsed = new Date(value).getTime();
  overrideMs = Number.isNaN(parsed) ? null : parsed;
}

function readDevNowCookie(): number | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)zoe\.dev_now=([^;]+)/);
  if (!match) return null;
  let raw = match[1];
  try {
    raw = decodeURIComponent(raw);
  } catch {
    /* Use raw */
  }
  const parsed = new Date(raw).getTime();
  return Number.isNaN(parsed) ? null : parsed;
}

/** Current time. */
export function now(): Date {
  if (import.meta.env.DEV) {
    if (overrideMs !== null) return new Date(overrideMs);
    const cookieMs = readDevNowCookie();
    if (cookieMs !== null) return new Date(cookieMs);
  }
  return new Date();
}

/** The one shared session-clock formatter. */
export function formatSessionClock(value: Date | string): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  });
}

export { DEV_NOW_COOKIE };
